module.exports = __webpack_public_path__ + "img/favicon.3da8377d.png";